import { Injectable } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { ValidationService } from '@app/shared/services/validation.service'
import { ProductServiceModel } from '@app/modules/product-service'
import { Product, ProductFormService } from '@app/modules/product'

@Injectable()

export class ProductServiceFormService {

  /**
   * Insert vaildators
   */
  public insertValidators: Array<any> = [
    {
      name: [
        ValidationService.noWhiteSpace,
        ValidationService.noEmojis,
        Validators.maxLength(191),
        Validators.required
      ]
    },
    {
      productUuid: [
        ValidationService.isUuid
      ]
    }
  ]

  /**
   * Update validators
   */
  public updateValidators: Array<any> = [
    {
      uuid: [
        Validators.required,
        ValidationService.isUuid
      ]
    }
  ]

  /**
   * Constructor
   */
  public constructor (
    private formBuilder: FormBuilder,
    public validationService: ValidationService,
    private productFormService: ProductFormService
  ) {}

  /**
   * Get form
   */
  public getForm (productService: ProductServiceModel, type: string): FormGroup {
    const form: FormGroup = this.formBuilder.group({
      uuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ],
      name: [
        null,
        [
          ValidationService.noWhiteSpace,
          ValidationService.noEmojis,
          Validators.maxLength(191)
        ]
      ],
      productUuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ],
      itemCode: [
        null,
        [
          ValidationService.noWhiteSpace,
          ValidationService.noEmojis,
          Validators.maxLength(191)
        ]
      ],
      itemType: [
        null,
        [
          ValidationService.noWhiteSpace,
          ValidationService.noEmojis,
          Validators.maxLength(191)
        ]
      ],
      quantity: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      unitCost: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      unitPrice: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      unitDiscount: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      discountType: [
        null,
        [
          ValidationService.noWhiteSpace,
          ValidationService.noEmojis,
          Validators.maxLength(191)
        ]
      ],
      discountPrice: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      extendedAmount: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      // Info.
      createdAt: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      updatedAt: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      deletedAt: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      createdByUuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ],
      updatedByUuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ]
    })

    if (type === 'new') {
      this.validationService.addInsertValidators(form, this.insertValidators)
    }

    if (type === 'edit') {
      this.validationService.addUpdateValidators(form, this.insertValidators, this.updateValidators)
    }

    if (productService.product) {
      form.addControl('product', this.productFormService.getForm(new Product(productService.product), ''))
    }

    // Patch the form.
    if (productService) {
      form.patchValue(productService, { emitEvent: false })
    }

    return form
  }

}
